import { _getEvents } from 'api/http/events'
import { makeRequest, createRequestStatuses } from 'redux/utils/redux-utils'

export const SET_EVENTS = createRequestStatuses('SET_EVENTS')
export const getEvents = (
  data,
  callbackSuccess,
  callbackError,
  paging,
  withoutLoading
) =>
  makeRequest(
    SET_EVENTS,
    _getEvents,
    data,
    callbackSuccess,
    callbackError,
    paging,
    withoutLoading
  )

export const SET_EVENT_FILTER = 'set_event_filter'

export const SET_EVENT_RED_STATUS = 'set_event_red_status'
